import styled from 'styled-components'
import { media } from '../../utilities/styled'
import Text from '../../primitives/text'
import Image from '../../primitives/image'

export const Container = styled.div`
  display: flex;
  width: 100%;

  ${media.tablet`
    align-items: center;
    flex-direction: row;
    flex-wrap: wrap;
  `};
`

export const StyledText = styled(Text)`
  margin-right: 48px;

  ${media.tablet`
    margin: auto;
    margin-bottom: 25px;
    width: 100%;
    text-align: center;
  `};
`

export const StyledImage = styled(Image)`
  height: 30px;
  flex: 0 0 auto;

  &:not(:first-child) {
    margin-left: 40px;
  }

  ${media.tablet`
    width: 33.3%;

    &:not(:first-child) {
      margin-left: 0px;
    }

    &:nth-child(-n+3) {
      margin-bottom: 30px;
    }
  `};
`
